import { render, staticRenderFns } from "./ManageStock.vue?vue&type=template&id=69ad98b5&scoped=true"
import script from "./ManageStock.vue?vue&type=script&lang=js"
export * from "./ManageStock.vue?vue&type=script&lang=js"
import style0 from "./ManageStock.vue?vue&type=style&index=0&id=69ad98b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ad98b5",
  null
  
)

export default component.exports